import { useState } from "react";
import { Copy, Check, Terminal, FileJson } from "lucide-react";

export function CodeBlock({
  code,
  language = "json",
  title,
}: {
  code: string;
  language?: string;
  title?: string;
}) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const getLanguageIcon = () => {
    switch (language) {
      case "json":
        return <FileJson className="w-3.5 h-3.5" />;
      default:
        return <Terminal className="w-3.5 h-3.5" />;
    }
  };

  return (
    <div className="rounded-xl border border-white/[0.08] overflow-hidden bg-[#0d0d0f]">
      {/* Header */}
      {title && (
        <div className="px-4 py-2.5 border-b border-white/[0.06] bg-white/[0.02] flex items-center justify-between">
          <div className="flex items-center gap-2 text-xs text-white/40">
            {getLanguageIcon()}
            <span className="font-mono">{title}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-2.5 h-2.5 rounded-full bg-white/[0.08]" />
            <div className="w-2.5 h-2.5 rounded-full bg-white/[0.08]" />
            <div className="w-2.5 h-2.5 rounded-full bg-white/[0.08]" />
          </div>
        </div>
      )}
      
      {/* Code Content */}
      <div className="relative group">
        <pre className="p-5 overflow-x-auto text-[13px] leading-relaxed font-mono">
          <code className="language-{language} text-white/70">{code}</code>
        </pre>
        
        {/* Copy Button */}
        <button
          onClick={copy}
          className="absolute top-3 right-3 p-2 rounded-lg bg-white/[0.04] hover:bg-white/[0.08] border border-white/[0.06] hover:border-white/[0.12] transition-all opacity-0 group-hover:opacity-100 focus:opacity-100"
          title="Copy to clipboard"
        >
          {copied ? (
            <Check className="w-4 h-4 text-green-400" />
          ) : (
            <Copy className="w-4 h-4 text-white/40" />
          )}
        </button>
      </div>
    </div>
  );
}
